import { useAtom } from 'jotai'
import { riskLayersAtom } from '@app/risk-migration/atoms/riskLayers.atoms'

export function useRiskLayersState() {
  const [layers, setLayers] = useAtom(riskLayersAtom)

  return {
    layers,
    setLayers,
  }
}
